import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tab,
  Tabs,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import axios from 'axios';
import Sidebar from '../../Drawer/Sidebar';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Reusable from './Reusables';
import {
  controlAllFeatureOptions,
  getControlAllFeatureOptionList,
} from '../../../configs/constants';
import {
  getConfiguration,
  getAppConfig,
  updateConfigRequest,
  clearMessage,
  updateSingleConfigRequest,
  saveAddressRequest,
  saveFirebaseSettingRequest,
  saveAdminFirebaseSettingRequest,
  getBenefitsAndFeatures,
} from '../../../redux/Configuration/configurationSlice';
import CreateCountryList from '../CountryCode/CreateCountryList';
import DocumentConfiguration from './DocumentConfiguration';
import { getActiveCountriesRequest } from '../../../redux/CountryList/CountrySlice';
import auth from '../../../configs/auth';
import { canShowPermission } from '../Permissions/permissionObject';
import { useTranslation } from 'react-i18next';
import AccessControl from '../../Comman/AccessControl';

const Section = ({ title, options, buttonText }) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        width: '49%',
        border: '1px solid #ccc',
      }}
    >
      <Typography fontWeight={700} fontSize={24} mb={3} fontFamily={'Aeonik'}>
        {title}
      </Typography>
      <FormGroup row sx={{ color: '#7B8499' }}>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                sx={{
                  color: '#7b8499', // Unchecked border color
                  '&.Mui-checked': {
                    color: '#4caf50', // Checked color
                  },
                }}
              />
            }
            label={
              <Typography
                variant="body2"
                fontFamily={'Inter'}
                fontSize={'14px'}
                fontWeight={'500'}
                color="#7b8499"
              >
                {option}
              </Typography>
            }
          />
        ))}
      </FormGroup>
      <Button
        variant="contained"
        sx={{ bgcolor: '#752ADA', px: 6, textTransform: 'none', mt: 3 }}
      >
        {buttonText}
      </Button>
    </Paper>
  );
};
const Configuration = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const message = useSelector((state) => state?.setting?.message);
  const error = useSelector((state) => state?.setting?.error);
  const configurationData = useSelector(
    (state) => state.appConfig.configurationData,
  );
  //get feature data
  const featuresData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.FeatureOptions || {},
  );
  //get app config data
  const configData = useSelector((state) => state?.appConfig?.configData || {});
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getConfiguration());
  }, []);
  //get features and benefits for control all feature
  useEffect(() => {
    dispatch(getAppConfig());
    dispatch(getBenefitsAndFeatures());
  }, []);

  useEffect(() => {
    if (Object.keys(configurationData).length) {
      setSmsCount(configurationData.availableSms ?? 0);
      setExistingBalance(Number(configurationData.availableSms) ?? 0);
      setOfflineOrder(configurationData.offlineOrder || '');
      setAppName(configurationData.appName || {});
      setSelectedGateway(configurationData.smsGateway || {});
      setRetailwareUrl(configurationData.retailware || []);
      setSelectedFile(configurationData.logo || []);
      setAcmeUrl(configurationData.acme || 0);
      setAppUrl(configurationData.appurl || 0);
      setJewellerNumber(configurationData.jewellerNumber || '');
      setKycLimit(configurationData.kyclimit || '');
      setSlideLimit(configurationData.slidelimit || '');
      setLookbookLimit(configurationData.lookbooklimit);
      setFeatureToggle(configData.featureToggle || {});
      setGraceSettings(
        configData?.gracePeriodDays
          ? {
              notifyJewellerDays:
                configData.gracePeriodDays.notifyJewellerDays ?? 0,
              notifyCustomerDays:
                configData.gracePeriodDays.notifyCustomerDays ?? 0,
              gracePeriodDays: configData.gracePeriodDays.gracePeriodDays ?? 0,
              gracePeriodDaysForCustomer:
                configData.gracePeriodDays.gracePeriodDaysForCustomer ?? 0,
            }
          : DEFAULT_GRACE,
      );
      setBillingType(configurationData.billingType || '');
      if (configurationData.cashfree) {
        setClientId(configurationData.cashfree.cashfreeClientId || '');
        setSecretKey(configurationData.cashfree.cashfreeSecretKey || '');
      }
      if (configurationData.paytm) {
        setMID(configurationData.paytm.mid || '');
        setMerchantKey(configurationData.paytm.merchantKey || '');
      }

      if (configurationData.payg) {
        setpaygmid(configurationData.payg.mid || '');
        setPaygAuthKey(configurationData.payg.paygAuthKey || '');
        setPaygAuthToken(configurationData.payg.paygAuthToken || '');
      }

      if (configurationData.ccavenue) {
        setCcavenueMerchantId(
          configurationData.ccavenue.ccavenueMerchantId || '',
        );
        setCcavenueAccessCode(
          configurationData.ccavenue.ccavenueAccessCode || '',
        );
        setCcavenueWorkingKey(
          configurationData.ccavenue.ccavenueWorkingKey || '',
        );
      }

      if (configurationData.nomod) {
        setNomodKey(configurationData.nomod.nomodKey || '');
      }

      if (configurationData.moneysip) {
        setMinMonth(configurationData.moneysip.minmonth || '');
        setMaxMonth(configurationData.moneysip.maxmonth || '');
        setMinAmount(configurationData.moneysip.minamount || '');
        setMaxAmount(configurationData.moneysip.maxamount || '');
        setMinGram(configurationData.moneysip.mingram || '');
        setMaxGram(configurationData.moneysip.maxgram || '');
      }

      if (configurationData.appVersion) {
        setAppVersion({ type: configurationData.appVersion || 'old' });
      }

      if (configurationData.firebase) {
        setFirebaseConfig({
          topicName: configurationData.firebase.topicName || '',
          firebaseProjectId: configurationData.firebase.firebaseProjectId || '',
          firebaseSdkPath: configurationData.firebase.firebaseSdkPath || '',
        });
      }

      const adminFirebase =
        configurationData.adminFirebase ||
        configurationData.admin_firebase ||
        configurationData.adminAppFirebase;

      if (adminFirebase) {
        setAdminFirebaseConfig({
          firebaseProjectId: adminFirebase.firebaseProjectId || '',
          firebaseSdkPath: adminFirebase.firebaseSdkPath || '',
        });
      }

      setIsChecked(configurationData.carouselstatus === 'true');
      setIsCheckedBullion(configurationData.bulliondepositstatus === 'true');
      setIsSmsChecked(configurationData.message === true);
      setIsCheckedRegistration(
        configurationData.registrationgiftstatus === 'true',
      );
      setIsCheckedBirthday(configurationData.birthdaygiftstatus === 'true');
      setIsCheckedOldGift(configurationData.oldgiftpopup === 'true');
      setIsBilling(configurationData.isBilling === 'true');
    }

    if (configurationData.loginoptions) {
      setLoginOptions({
        EMAIL: configurationData.loginoptions.EMAIL === 'true',
        SMS: configurationData.loginoptions.SMS === 'true',
      });
    }

    if (configurationData.productoptions) {
      setProductOptions({
        booknow: configurationData.productoptions.booknow === 'true',
        enquirenow: configurationData.productoptions.enquirenow === 'true',
      });
    }

    if (configurationData.productPurchase) {
      setProductPurchase({
        online: configurationData.productPurchase.online === 'true',
        offline: configurationData.productPurchase.offline === 'true',
      });
    }

    if (configurationData.moneysipstatus) {
      setSipStatus({
        moneysipstatus:
          configurationData.moneysipstatus.moneysipstatus === 'true',
        metalsipstatus:
          configurationData.moneysipstatus.metalsipstatus === 'true',
      });
    }
    if (configurationData.buyautodebit) {
      setFrequency({
        DAY: configurationData.buyautodebit.DAY,
        WEEK: configurationData.buyautodebit.WEEK,
        MONTH: configurationData.buyautodebit.MONTH,
      });
    }

    if (configurationData.bulliondeposit) {
      setGiftbalance(configurationData.bulliondeposit.giftbalance === 'true');
      setHoldings(configurationData.bulliondeposit.holdings === 'true');
    }
    setJewellerStateCode(
      typeof configurationData.jewellerStateCode === 'string' ||
        typeof configurationData.jewellerStateCode === 'number'
        ? configurationData.jewellerStateCode.toString()
        : '',
    );
  }, [configurationData]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearMessage());
    } else if (message) {
      toast.success(message);
      dispatch(clearMessage());
    }
  }, [message, error, dispatch]);
  const [smsCount, setSmsCount] = useState('');
  const [offlineOrder, setOfflineOrder] = useState(0);
  const [appName, setAppName] = useState('');
  const [jewellerNumber, setJewellerNumber] = useState('');
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
  const [minAmount, setMinAmount] = useState('');
  const [maxAmount, setMaxAmount] = useState('');
  const [minGram, setMinGram] = useState('');
  const [maxGram, setMaxGram] = useState('');
  const [kycLimit, setKycLimit] = useState('');
  const [slideLimit, setSlideLimit] = useState('');
  const [lookbookLimit, setLookbookLimit] = useState('');

  const [selectedGateway, setSelectedGateway] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [isBilling, setIsBilling] = useState(false);
  const [billingType, setBillingType] = useState('acme');
  const [isCheckedBullion, setIsCheckedBullion] = useState(false);
  const [isSmsChecked, setIsSmsChecked] = useState();
  const [isCheckedRegistration, setIsCheckedRegistration] = useState(false);
  const [isCheckedBirthday, setIsCheckedBirthday] = useState(false);
  const [isCheckedOldGift, setIsCheckedOldGift] = useState(false);
  const [clientId, setClientId] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [firebaseProjectId, setFirebaseProjectId] = useState('');
  const [topicName, setTopicName] = useState('');
  const [firebaseSdkPath, setFirebaseSdkPath] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('No file chosen');
  const [previewUrl, setPreviewUrl] = useState('');
  const [featureToggle, setFeatureToggle] = useState(featuresData);
  const [frequency, setFrequency] = useState({
    DAY: false,
    WEEK: false,
    MONTH: false,
  });
  const [form, setForm] = useState({
    line1: '',
    line2: '',
    phone: '',
    email: '',
    gstin: '',
    cin: '',
    pincode: '',
    countryCode: '',
    state: '',
  });
  const [addressId, setAddressId] = useState('');
  //notify jeweller and customer settings
  const DEFAULT_GRACE = {
    notifyJewellerDays: 0,
    notifyCustomerDays: 0,
    gracePeriodDays: 0,
    gracePeriodDaysForCustomer: 0,
  };
  const [graceSettings, setGraceSettings] = useState(DEFAULT_GRACE);

  const [appVersion, setAppVersion] = useState({ type: 'old' });
const [isSavingAppVersion, setIsSavingAppVersion] = useState(false);

  const [jewellerOnBoardingDays, setJewellerOnBoardingDays] = useState('');
  useEffect(() => {
    if (Object.keys(configData).length) {
      setJewellerOnBoardingDays(configData.jewellerOnBoardingDays || '');
    }
  }, [configData]);
  const handelJewellerOnBoardingDays = () => {
    dispatch(
      updateConfigRequest({
        key: 'jewellerOnBoardingDays',
        value: jewellerOnBoardingDays,
      }),
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const [selectedDialCode, setSelectedDialCode] = useState('+91'); // default dial code
  const [phoneLength, setPhoneLength] = useState(10);

  const selectedCountry = activeCountries.find(
    (c) => c._id === form.countryCode,
  );
  const statesList = selectedCountry?.states || [];

  const handleSaveAddress = () => {
    const {
      line1,
      line2,
      phone,
      gstin,
      cin,
      pincode,
      countryCode,
      state,
      email,
    } = form;

    if (
      !line1.trim() ||
      !line2.trim() ||
      !phone.trim() ||
      !email.trim() ||
      !gstin.trim() ||
      !pincode.trim() ||
      !countryCode.trim() ||
      !state.trim()
    ) {
      toast.error('Please fill all required fields');
      return;
    }

    if (phone.length !== phoneLength) {
      toast.error(`Phone number must be exactly ${phoneLength} digits`);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email.trim())) {
      toast.error('Please enter a valid email address');
      return;
    }

    const payload = {
      address1: line1,
      address2: line2,
      phone,
      email: email.trim().toLowerCase(),
      gst: gstin,
      cin,
      pincode,
      address3: '',
      area: '',
      city: '',
      state: form.state,
      addressType: 'Home',
      countryCode: countryCode,
    };

    if (addressId) {
      payload.existingId = addressId;
    }

    dispatch(saveAddressRequest(payload));
  };
  useEffect(() => {
    const addr = configurationData?.address || {};
    setAddressId(addr?._id || '');
    const country = configurationData.address.countryCode;
    setForm({
      line1: configurationData?.address?.address1 || '',
      line2: configurationData?.address?.address2 || '',
      phone: configurationData?.address?.phone || '',
      email: configurationData?.address?.email || '',
      gstin: configurationData?.address?.gst || '',
      cin: configurationData?.address?.cin || '',
      pincode: configurationData?.address?.pincode || '',
      countryCode: configurationData?.address?.countryCode?._id || '',
      state: configurationData?.address?.state || '',
    });
    if (country) {
      setSelectedDialCode(country.dialCode);
      setPhoneLength(country.phoneLength);
    }
  }, [configurationData?.address]);

  useEffect(() => {
    if (
      configurationData &&
      configurationData.address &&
      configurationData.address.countryCode &&
      activeCountries.length
    ) {
      const country = activeCountries.find(
        (c) => c._id === configurationData.address.countryCode,
      );
      if (country) {
        setSelectedDialCode(country.dialCode);
        setPhoneLength(country.phoneLength);
      }
    }
  }, [configurationData, activeCountries]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error('Please choose a file before uploading');
      return;
    }

    const formData = new FormData();
    formData.append('name', 'logo');
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/updateSingleConfig`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (response.data.status) {
        toast.success('Logo uploaded and saved successfully');
      } else {
        toast.error('Upload failed');
      }
    } catch (error) {
      toast.error('An error occurred during upload');
      console.error(error);
    }
  };

  const [firebaseConfig, setFirebaseConfig] = useState({
    topicName: '',
    firebaseProjectId: '',
    firebaseSdkPath: '',
  });

  const [adminFirebaseConfig, setAdminFirebaseConfig] = useState({
    firebaseProjectId: '',
    firebaseSdkPath: '',
  });

  const fetchAdminFirebaseSetting = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getAdminFirebaseSetting`,
      );
      const responseData = response?.data || {};
      const data =
        responseData?.value ||
        responseData?.data?.value ||
        responseData?.data ||
        {};

      setAdminFirebaseConfig((prev) => ({
        ...prev,
        firebaseProjectId: data.firebaseProjectId || '',
        firebaseSdkPath: data.firebaseSdkPath || '',
      }));
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(`Failed to fetch admin firebase setting: ${message}`);
    }
  };

  const handlePreviewFile = (fileUrl) => {
    try {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(`Failed to open preview: ${message}`);
    }
  };

  useEffect(() => {
    fetchAdminFirebaseSetting();
  }, []);

  const handleSaveFirebaseConfig = () => {
    const { firebaseProjectId, topicName, firebaseSdkPath } = firebaseConfig;
    const isFirebaseSdkFile =
      firebaseSdkPath &&
      typeof firebaseSdkPath === 'object' &&
      'name' in firebaseSdkPath &&
      'size' in firebaseSdkPath;

    if (!firebaseProjectId.trim() || !topicName.trim() || !isFirebaseSdkFile) {
      toast.error(
        'Please provide firebaseProjectId, topicName and upload JSON file',
      );
      return;
    }

    dispatch(
      saveFirebaseSettingRequest({
        name: 'firebase',
        value: {
          firebaseProjectId,
          topicName,
          file: firebaseSdkPath,
        },
      }),
    );
  };

  const handleSaveAdminFirebaseConfig = () => {
    const { firebaseProjectId, firebaseSdkPath } = adminFirebaseConfig;
    const isFirebaseSdkFile =
      firebaseSdkPath &&
      typeof firebaseSdkPath === 'object' &&
      'name' in firebaseSdkPath &&
      'size' in firebaseSdkPath;

    if (!firebaseProjectId.trim() || !isFirebaseSdkFile) {
      toast.error('Please provide firebaseProjectId and upload JSON file');
      return;
    }

    dispatch(
      saveAdminFirebaseSettingRequest({
        name: 'adminFirebase',
        value: {
          firebaseProjectId,
          file: firebaseSdkPath,
        },
      }),
    );
  };

  const handleSaveCashfree = () => {
    if (!clientId.trim() || !secretKey.trim()) {
      toast.error('Both Cashfree Client ID and Secret Key are required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'cashfree',
        value: {
          cashfreeClientId: clientId,
          cashfreeSecretKey: secretKey,
        },
      }),
    );
  };

  const [giftbalance, setGiftbalance] = useState(false);
  const [holdings, setHoldings] = useState(false);

  const handleSaveBullionDeposit = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'bulliondeposit',
        value: {
          giftbalance: giftbalance === true ? 'true' : 'false',
          holdings: holdings === true ? 'true' : 'false',
        },
      }),
    );
  };

  const handleHoldingsChange = (e) => {
    if (e.target.checked) {
      setHoldings(true);
      setGiftbalance(false); // Uncheck giftbalance if holdings is checked
    } else {
      setHoldings(false);
    }
  };

  const handleGiftBalanceChange = (e) => {
    if (e.target.checked) {
      setGiftbalance(true);
      setHoldings(false); // Uncheck holdings if giftbalance is checked
    } else {
      setGiftbalance(false);
    }
  };

  const [mID, setMID] = useState('');
  const [merchantKey, setMerchantKey] = useState('');

  const handleSavePaytmKeys = () => {
    if (!mID.trim() || !merchantKey.trim()) {
      toast.error('Both paytm MID and merchantKey are required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'paytm',
        value: {
          mid: mID,
          merchantKey: merchantKey,
        },
      }),
    );
  };

  const [paygmid, setpaygmid] = useState('');
  const [paygAuthKey, setPaygAuthKey] = useState('');
  const [paygAuthToken, setPaygAuthToken] = useState('');
  const handleSavePaygKey = () => {
    if (!paygmid.trim() || !paygAuthKey.trim() || !paygAuthToken.trim()) {
      toast.error(' paygmid , paygAuthKey and paygAuthToken are required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'payg',
        value: {
          mid: paygmid,
          paygAuthKey: paygAuthKey,
          paygAuthToken: paygAuthToken,
        },
      }),
    );
  };

  const [ccavenueMerchantId, setCcavenueMerchantId] = useState('');
  const [ccavenueAccessCode, setCcavenueAccessCode] = useState('');
  const [ccavenueWorkingKey, setCcavenueWorkingKey] = useState('');
  const handleSaveccavenue = () => {
    if (
      !ccavenueMerchantId.trim() ||
      !ccavenueAccessCode.trim() ||
      !ccavenueWorkingKey.trim()
    ) {
      toast.error(
        ' ccavenueMerchantId , ccavenueAccessCode and ccavenueWorkingKey are required',
      );
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'ccavenue',
        value: {
          ccavenueMerchantId: ccavenueMerchantId,
          ccavenueAccessCode: ccavenueAccessCode,
          ccavenueWorkingKey: ccavenueWorkingKey,
        },
      }),
    );
  };

  const handleChangeBuyAutoDebit = (key) => (e, checked) => {
    setFrequency((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  const handleSaveBuyAutoDebit = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'buyautodebit',
        value: {
          DAY: frequency.DAY,
          WEEK: frequency.WEEK,
          MONTH: frequency.MONTH,
        },
      }),
    );
  };

  const [nomodKey, setNomodKey] = useState('');
  const handleSaveNomodKeys = () => {
    if (!nomodKey.trim()) {
      toast.error('Nomod key is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'nomod',
        value: {
          nomodKey: nomodKey,
        },
      }),
    );
  };

  const [openDialog, setOpenDialog] = useState(false);
  const handleSaveBilling = () => {
    if (!billingType || billingType === 'Billing') {
      setOpenDialog(true);
      return;
    }
    dispatch(
      updateSingleConfigRequest({
        name: 'isBilling',
        value: isBilling ? 'true' : 'false',
      }),
    );
    dispatch(
      updateSingleConfigRequest({ name: 'billingType', value: billingType }),
    );
  };

  const [sipStatus, setSipStatus] = useState({
    moneysipstatus: false,
    metalsipstatus: false,
  });
  const [retailwareUrl, setRetailwareUrl] = useState('');
  const handleRetailwareUrl = () => {
    if (!retailwareUrl) {
      toast.error('retailwareUrl is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'retailware',
        value: String(retailwareUrl),
      }),
    );
  };

  const [acme, setAcmeUrl] = useState('');
  const handleAcmeUrl = () => {
    if (!acme) {
      toast.error('acme is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'acme',
        value: String(acme),
      }),
    );
  };

  const [jewellerStateCode, setJewellerStateCode] = useState('');
  const handleJewellerStateCode = () => {
    if (!jewellerStateCode) {
      toast.error('jewellerStateCode is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'jewellerStateCode',
        value: jewellerStateCode,
      }),
    );
  };

  const [appurl, setAppUrl] = useState('');
  const handleAppUrl = () => {
    if (!appurl) {
      toast.error('appurl is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'appurl',
        value: String(appurl),
      }),
    );
  };

  const handleSaveSipStatus = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'moneysipstatus',
        value: {
          moneysipstatus: sipStatus.moneysipstatus ? 'true' : 'false',
          metalsipstatus: sipStatus.metalsipstatus ? 'true' : 'false',
        },
      }),
    );
  };

  const [sipLuckyDrawStatus, setSipLuckyDrawStatus] = useState(false);

  const handleSaveSipLuckyDrawStatus = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'sipLuckyDraw',
        value: sipLuckyDrawStatus ? 'true' : 'false',
      }),
    );
  };

  useEffect(() => {
    if (configurationData.sipLuckyDraw) {
      setSipLuckyDrawStatus(configurationData.sipLuckyDraw === 'true');
    }
  }, [configurationData]);
  const [productPurchase, setProductPurchase] = useState({
    online: false,
    offline: false,
  });
  //notify jeweller updateConfigRequest
  const handleSaveGraceSettings = () => {
    if (
      graceSettings.notifyJewellerDays === '' ||
      graceSettings.notifyCustomerDays === '' ||
      graceSettings.gracePeriodDays === '' ||
      graceSettings.gracePeriodDaysForCustomer === ''
    ) {
      toast.error('All fields are required');
      return;
    }
    dispatch(
      updateConfigRequest({
        key: 'gracePeriodDays',
        value: {
          notifyJewellerDays: graceSettings.notifyJewellerDays,
          notifyCustomerDays: graceSettings.notifyCustomerDays,
          gracePeriodDays: graceSettings.gracePeriodDays,
          gracePeriodDaysForCustomer: graceSettings.gracePeriodDaysForCustomer,
        },
      }),
    );
  };

  const handleSaveProductPurchase = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'productPurchase',
        value: {
          online: productPurchase.online ? 'true' : 'false',
          offline: productPurchase.offline ? 'true' : 'false',
        },
      }),
    );
  };

  const [productOptions, setProductOptions] = useState({
    booknow: false,
    enquirenow: false,
  });

  const handleSaveProductOptions = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'productoptions',
        value: {
          booknow: productOptions.booknow ? 'true' : 'false',
          enquirenow: productOptions.enquirenow ? 'true' : 'false',
        },
      }),
    );
  };

  const handleSaveoldgiftpopup = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'oldgiftpopup',
        value: isCheckedOldGift ? 'true' : 'false',
      }),
    );
  };

  const [loginOptions, setLoginOptions] = useState({
    EMAIL: false,
    SMS: false,
  });

  const handleSaveLoginOptions = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'loginoptions',
        value: {
          EMAIL: loginOptions.EMAIL ? 'true' : 'false',
          SMS: loginOptions.SMS ? 'true' : 'false',
        },
      }),
    );
  };

  const handleSaveBirthday = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'birthdaygiftstatus',
        value: isCheckedBirthday ? 'true' : 'false',
      }),
    );
  };

  const handleSaveRegistration = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'registrationgiftstatus',
        value: isCheckedRegistration ? 'true' : 'false',
      }),
    );
  };

  const handleSaveBullion = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'bulliondepositstatus',
        value: isCheckedBullion ? 'true' : 'false',
      }),
    );
  };

  const handleSaveSmsStatus = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'message',
        value: isSmsChecked ? true : false,
      }),
    );
  };

  const handleSave = () => {
    dispatch(
      updateSingleConfigRequest({
        name: 'carouselstatus',
        value: isChecked ? 'true' : 'false',
      }),
    );
  };
  const handleSaveLookbookLimit = () => {
    if (!lookbookLimit) {
      toast.error('Lookbook Slide Limit is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'lookbooklimit',
        value: String(lookbookLimit),
      }),
    );
  };

  const handleSaveSlideLimit = () => {
    if (!slideLimit) {
      toast.error('Slide Limit is required');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'slidelimit',
        value: String(slideLimit),
      }),
    );
  };

  const handleSaveKycLimit = () => {
    if (!kycLimit) {
      toast.error('KYC Limit is required');
      return;
    }

    const numericValue = Number(kycLimit);

    if (isNaN(numericValue)) {
      toast.error('KYC Limit must be a valid number');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'kyclimit',
        value: numericValue,
      }),
    );
  };

  const handleSmsGatewayUpdate = () => {
    if (!selectedGateway) {
      toast.error('Please select a SMS Gateway');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'smsGateway',
        value: selectedGateway,
      }),
    );
  };

  const handleSaveSipConfig = () => {
    if (
      !minMonth ||
      !maxMonth ||
      !minAmount ||
      !maxAmount ||
      !minGram ||
      !maxGram
    ) {
      toast.error('All SIP fields are required');
      return;
    }

    if (parseInt(minMonth, 10) > parseInt(maxMonth, 10)) {
      toast.error('Min Month cannot be greater than Max Month');
      return;
    }

    if (parseFloat(minGram) > parseFloat(maxGram)) {
      toast.error('Min Gram cannot be greater than Max Gram');
      return;
    }

    const moneysip = {
      minmonth: String(minMonth),
      maxmonth: String(maxMonth),
      minamount: parseFloat(minAmount).toFixed(2),
      maxamount: parseFloat(maxAmount).toFixed(2),
      mingram: parseFloat(minGram).toFixed(3),
      maxgram: parseFloat(maxGram).toFixed(3),
    };

    dispatch(
      updateSingleConfigRequest({
        name: 'moneysip',
        value: moneysip,
      }),
    );
  };

  const handleJewellerNumber = () => {
    if (!jewellerNumber) {
      toast.error('Please enter Jeweller Number');
      return;
    }

    const number = jewellerNumber;
    const isValid = /^\d{5,13}$/.test(number);

    if (!isValid) {
      toast.error('Please Enter Valid Jeweller Number');
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: 'jewellerNumber',
        value: Number(number),
      }),
    );
  };

  const [existingBalance, setExistingBalance] = useState();
  const [openConfirm, setOpenConfirm] = useState(false);

  const handelSmsCount = () => {
    if (!smsCount) {
      toast.error('SMS Quantity cannot be empty');
      return;
    }

    const enteredValue = Number(smsCount);
    const currentBalance = Number(existingBalance);

    if (isNaN(enteredValue) || enteredValue <= 0) {
      toast.error('Please enter a valid SMS quantity greater than 0');
      return;
    }

    const updatedBalance = currentBalance + enteredValue;

    dispatch(
      updateSingleConfigRequest({
        name: 'available_sms',
        value: updatedBalance,
      }),
    );
    setOpenConfirm(false);
  };

  const handelOfflineOrder = () => {
    if (!offlineOrder) {
      toast.error('offlineOrder cannot be empty');
      return;
    }
    dispatch(
      updateSingleConfigRequest({ name: 'offline_order', value: offlineOrder }),
    );
  };

  const handelAppName = () => {
    if (!appName) {
      toast.error('appName cannot be empty');
      return;
    }
    dispatch(updateSingleConfigRequest({ name: 'appName', value: appName }));
  };

  const handleSaveAppVersion = async () => {
  if (!appVersion.type) {
    toast.error('App Version type is required');
    return;
  }
  setIsSavingAppVersion(true);
  try {
    await dispatch(
      updateSingleConfigRequest({
        name: 'appVersion', 
        value: appVersion.type,
      }),
    );
  } finally {
    setIsSavingAppVersion(false);
  }
};

  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem('userPermissions');
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error('Error parsing stored permissions', error);
      }
    }
  }, []);
  const canCreateSetting = canShowPermission(
    permissions,
    'configuration',
    'create',
  );
  const canEdit = canShowPermission(permissions, 'configuration', 'edit');
  const canDelete = canShowPermission(permissions, 'configuration', 'delete');
  const [mainTab, setMainTab] = useState(0);
  const [subTab, setSubTab] = useState(0);
  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          mt: { xs: 10, md: 10 },
          background: '#fff',
          borderRadius: '16px',

          mb: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Typography
          fontFamily={'Aeonik'}
          sx={{ fontSize: '24px', fontWeight: 700, p: 2 }}
        >
          Configurations{' '}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={mainTab}
            onChange={(e, val) => {
              setMainTab(val);
              setSubTab(0); // reset subtabs
            }}
            sx={{
              borderRight: 1,
              borderColor: 'divider',
              minWidth: 180,
              width: '20%',
              maxHeight: '80vh',
              overflowY: 'auto',
              mt: 0,

              '& .MuiTab-root': {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                textAlign: 'left',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 600,
                fontStyle: 'inherit',
                fontFamily: 'initial', // ✅ apply font family to all tabs
              },
              '& .Mui-selected': {
                color: 'primary.main',
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                borderLeft: '3px solid',
                borderColor: 'primary.main',
              },

              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#bbb',
                borderRadius: '10px',
              },
            }}
          >
            <Tab label={t('configuration.jewellerDetails')} />
            <Tab label={t('configuration.limits')} />
            <Tab label={t('configuration.smsGateway')} />
            <Tab label={t('configuration.paymentGateways')} />
            <Tab label={t('configuration.billingIntegration')} />
            <Tab label={t('configuration.firebaseConfiguration')} />
            <Tab label={t('configuration.oneLinkUrl')} />
            <Tab label={t('configuration.carouselLookbookStatus')} />
            <Tab label={t('configuration.bullionDeposit')} />
            <Tab label={t('configuration.gifts')} />
            <Tab label={t('configuration.dashboardLoginOptions')} />
            <Tab label={t('configuration.product')} />
            <Tab label={t('configuration.sip')} />
            <Tab label={t('configuration.countries')} />
            <Tab label={t('configuration.controlAllFeature')} />
            <Tab label={t('configuration.jewellerAndCustomerNotification')} />
            <Tab label={t('Buy Auto Debit')} />
            <Tab label={t('Jeweller OnBoarding Days')} />
            <Tab label={t('configuration.appVersion')} />
            <Tab label={t('configuration.documentConfiguration')} />
          </Tabs>
          {/* Offineline Payment and Address section */}
          <Box sx={{ width: '80%', ml: '10px', mt: 0 }}>
            {/* Merged Jeweller Details Section - Logo, AppName, Address, State Code, Jeweller Number */}
            {mainTab === 0 && (
              <>
                {/* Logo and App Name Section - Combined at top */}
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: '100%', border: '1px solid #ccc', mb: 3 }}
                >
                  <Grid container spacing={3}>
                    {/* Logo Section */}
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontWeight={700}
                        fontSize={20}
                        mb={2}
                        fontFamily={'Aeonik'}
                      >
                        Logo
                      </Typography>
                      <Box display="flex" alignItems="center" gap={2} mb={2}>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                          id="file-upload"
                        />
                        <label htmlFor="file-upload">
                          <Button variant="outlined" component="span">
                            Choose File
                          </Button>
                        </label>
                        <Typography variant="body2">{fileName}</Typography>
                      </Box>
                      {previewUrl && (
                        <Box mt={2} mb={2}>
                          <img
                            src={previewUrl}
                            alt="Preview"
                            style={{ width: 100, height: 'auto' }}
                          />
                        </Box>
                      )}
                      {(canCreateSetting || canEdit)?.logo && (
                        <Box mt={2}>
                          <Typography variant="body2" mb={1}>
                            Stored Logo Preview:
                          </Typography>
                          <img
                            src={configurationData.logo}
                            alt="Stored Logo"
                            style={{
                              width: 100,
                              height: 'auto',
                              border: '1px solid #ccc',
                              borderRadius: '6px',
                              padding: '4px',
                            }}
                          />
                        </Box>
                      )}
                      {(canCreateSetting || canEdit) && (
                        <Button
                          onClick={handleUpload}
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 4,
                            textTransform: 'none',
                            mt: 2,
                          }}
                        >
                          Upload Logo
                        </Button>
                      )}
                    </Grid>

                    {/* App Name Section */}
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontWeight={700}
                        fontSize={20}
                        mb={2}
                        fontFamily={'Aeonik'}
                      >
                        App Name
                      </Typography>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('configuration.appName')}
                        placeholder={t('configuration.demo')}
                        value={appName}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^[A-Za-z ]*$/.test(input)) {
                            setAppName(input);
                          }
                        }}
                        sx={{ mb: 2 }}
                      />
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 4,
                            textTransform: 'none',
                            mt: 1,
                          }}
                          onClick={handelAppName}
                        >
                          Save App Name
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Paper>

                {/* Address Section */}
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: '100%', border: '1px solid #ccc', mb: 3 }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    Address
                  </Typography>

                  {/* Line 1,line 2 */}
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="line1"
                        label={t('configuration.line1')}
                        placeholder={t('configuration.addAddress')}
                        size="small"
                        value={form.line1}
                        onChange={(e) => {
                          const value = e.target.value;
                          setForm((prev) => ({ ...prev, line1: value }));
                        }}
                      />
                    </Grid>
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="line2"
                        label={t('configuration.line2')}
                        placeholder={t('configuration.addAddress')}
                        size="small"
                        value={form.line2}
                        onChange={(e) => {
                          const value = e.target.value;
                          setForm((prev) => ({ ...prev, line2: value }));
                        }}
                      />
                    </Grid>
                  </Grid>

                  {/* Phone and CIN */}
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="phone"
                        label={t('configuration.phoneNumber')}
                        placeholder={`Enter ${phoneLength}-digit number`}
                        size="small"
                        value={form.phone}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            /^\d*$/.test(value) &&
                            value.length <= phoneLength
                          ) {
                            setForm((prev) => ({ ...prev, phone: value }));
                          }
                        }}
                        disabled={!form.countryCode}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Select
                                value={form.countryCode || ''}
                                onChange={(e) => {
                                  const country = activeCountries.find(
                                    (c) => c._id === e.target.value,
                                  );
                                  if (country) {
                                    setForm((prev) => ({
                                      ...prev,
                                      countryCode: country._id,
                                      phone: '',
                                    }));
                                    setSelectedDialCode(country.dialCode);
                                    setPhoneLength(country.phoneLength);
                                  }
                                }}
                                variant="standard"
                                disableUnderline
                                sx={{
                                  minWidth: 80,
                                  '& .MuiSelect-select': {
                                    paddingRight: '24px !important',
                                  },
                                }}
                              >
                                {activeCountries.map((country) => (
                                  <MenuItem
                                    key={country._id}
                                    value={country._id}
                                  >
                                    {country.dialCode}
                                  </MenuItem>
                                ))}
                              </Select>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="email"
                        label="Email"
                        placeholder="Enter email address"
                        size="small"
                        value={form.email}
                        onChange={(e) => {
                          setForm((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>

                  {/* GST and Pincode */}
                  <Grid
                    container
                    spacing={2}
                    sx={{ mt: 2 }}
                    alignItems="center"
                  >
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="gstin"
                        label={t('configuration.gstin')}
                        placeholder={t('configuration.addGst')}
                        size="small"
                        value={form.gstin}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z0-9]*$/.test(value) || value === '') {
                            setForm((prev) => ({ ...prev, gstin: value }));
                          }
                        }}
                      />
                    </Grid>
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="cin"
                        label={t('configuration.cin')}
                        placeholder={t('configuration.addCin')}
                        size="small"
                        value={form.cin}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z0-9]*$/.test(value) || value === '') {
                            setForm((prev) => ({ ...prev, cin: value }));
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    sx={{ mt: 2 }}
                    alignItems="center"
                  >
                    <Grid item size={6}>
                      <FormControl
                        fullWidth
                        size="small"
                        disabled={!form.countryCode}
                      >
                        <InputLabel id="state-select-label">State</InputLabel>
                        <Select
                          labelId="state-select-label"
                          id="state-select"
                          label={t('configuration.state')}
                          value={form.state}
                          onChange={(e) =>
                            setForm((prev) => ({
                              ...prev,
                              state: e.target.value,
                            }))
                          }
                        >
                          <MenuItem value="" disabled>
                            Select State
                          </MenuItem>
                          {statesList.map((state) => (
                            <MenuItem key={state} value={state}>
                              {state}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item size={6}>
                      <TextField
                        fullWidth
                        name="pincode"
                        label={t('configuration.pincode')}
                        placeholder={t('configuration.addPincode')}
                        size="small"
                        value={form.pincode}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only digits, must not start with 0
                          if (/^[1-9][0-9]*$/.test(value) || value === '') {
                            setForm((prev) => ({ ...prev, pincode: value }));
                          }
                        }}
                      />
                    </Grid>
                  </Grid>

                  {/* Save Button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 3,
                      }}
                      onClick={handleSaveAddress}
                    >
                      Save Address
                    </Button>
                  )}
                </Paper>

                {/* Jeweller State Code and Jeweller Number for bulkgift Section - Combined */}
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: '100%', border: '1px solid #ccc' }}
                >
                  <Grid container spacing={3}>
                    {/* Jeweller State Code Section */}
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontWeight={700}
                        fontSize={20}
                        mb={2}
                        fontFamily={'Aeonik'}
                      >
                        Jeweller State Code
                      </Typography>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('configuration.jewellerStateCode')}
                        placeholder={t('configuration.jewellerStateCode')}
                        value={jewellerStateCode}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^[0-9]+$/.test(input) || input === '') {
                            setJewellerStateCode(input);
                          }
                        }}
                        sx={{ mb: 2 }}
                      />
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 4,
                            textTransform: 'none',
                            mt: 1,
                          }}
                          onClick={handleJewellerStateCode}
                        >
                          Save State Code
                        </Button>
                      )}
                    </Grid>

                    {/* Jeweller Number for bulkgift Section */}
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontWeight={700}
                        fontSize={20}
                        mb={2}
                        fontFamily={'Aeonik'}
                      >
                        Jeweller Number for bulkgift
                      </Typography>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('configuration.jewellerNumber')}
                        placeholder={t('configuration.jewellerNumberBulkgift')}
                        value={jewellerNumber}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^\d{0,13}$/.test(input)) {
                            setJewellerNumber(input);
                          }
                        }}
                        sx={{ mb: 2 }}
                      />
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 4,
                            textTransform: 'none',
                            mt: 1,
                          }}
                          onClick={handleJewellerNumber}
                        >
                          Save Jeweller Number
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </>
            )}

            {/* Limits Section with Sub-tabs */}
            {mainTab === 1 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label={t('configuration.smsQuantity')} />
                  <Tab label={t('configuration.offlineOrderLimit')} />
                  <Tab label={t('configuration.kycApprovedBuyLimit')} />
                  <Tab label={t('configuration.minimumCarouselSlideLimit')} />
                  <Tab label={t('configuration.minimumLookbookSlideLimit')} />
                </Tabs>

                {/* SMS Quantity Sub-tab */}
                {subTab === 0 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: '100%',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={'Aeonik'}
                    >
                      SMS Quantity
                    </Typography>
                    <Grid container spacing={2}>
                      <TextField
                        size="small"
                        fullWidth
                        label={`SMS Quantity *Available Balance(${existingBalance})`}
                        placeholder={t('configuration.enterQuantity')}
                        value={smsCount}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^[1-9][0-9]*$/.test(input) || input === '') {
                            setSmsCount(input.trim());
                          }
                        }}
                        sx={{
                          width: '100%',
                          minWidth: { xs: '210px', sm: '332px' },
                        }}
                      />
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#752ADA',
                          px: 6,
                          textTransform: 'none',
                          mt: 3,
                        }}
                        onClick={() => setOpenConfirm(true)}
                      >
                        Add
                      </Button>
                    )}
                  </Paper>
                )}

                {/* Offline Order Limit Sub-tab */}
                {subTab === 1 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: '100%',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={'Aeonik'}
                    >
                      Offline Order Limit
                    </Typography>
                    <Grid container spacing={2}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('configuration.offlineOrderLimit')}
                        placeholder={t('configuration.offlineOrderLimit')}
                        value={offlineOrder}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^[1-9][0-9]*$/.test(input) || input === '') {
                            setOfflineOrder(input.trim());
                          }
                        }}
                      />
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#752ADA',
                          px: 6,
                          textTransform: 'none',
                          mt: 3,
                        }}
                        onClick={handelOfflineOrder}
                      >
                        Add
                      </Button>
                    )}
                  </Paper>
                )}

                {/* KYC Approved Buy Limit Sub-tab */}
                {subTab === 2 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: '100%',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={'Aeonik'}
                    >
                      KYC Approved Buy Limit
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item size={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t('configuration.kycLimit')}
                          placeholder={t(
                            'configuration.enterKycApprovedBuyLimit',
                          )}
                          value={kycLimit}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^[1-9][0-9]*$/.test(input) || input === '') {
                              setKycLimit(input);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#752ADA',
                          px: 6,
                          textTransform: 'none',
                          mt: 3,
                        }}
                        onClick={handleSaveKycLimit}
                      >
                        Save
                      </Button>
                    )}
                  </Paper>
                )}

                {/* Minimum Carousel Slide Limit Sub-tab */}
                {subTab === 3 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: '100%',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={'Aeonik'}
                    >
                      Minimum Carousel Slide Limit
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item size={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t('configuration.carouselSlideLimitNote')}
                          placeholder="5"
                          value={slideLimit}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^[1-9][0-9]*$/.test(input) || input === '') {
                              setSlideLimit(input);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#752ADA',
                          px: 6,
                          textTransform: 'none',
                          mt: 3,
                        }}
                        onClick={handleSaveSlideLimit}
                      >
                        Save
                      </Button>
                    )}
                  </Paper>
                )}

                {/* Minimum Lookbook Slide Limit Sub-tab */}
                {subTab === 4 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: '100%',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={'Aeonik'}
                    >
                      Minimum Lookbook Slide Limit
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item size={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t('configuration.lookbookSlideLimitNote')}
                          placeholder="4"
                          value={lookbookLimit}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^[1-9][0-9]*$/.test(input) || input === '') {
                              setLookbookLimit(input);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#752ADA',
                          px: 6,
                          textTransform: 'none',
                          mt: 3,
                        }}
                        onClick={handleSaveLookbookLimit}
                      >
                        Save
                      </Button>
                    )}
                  </Paper>
                )}
              </>
            )}

            {/* Sms Gateway section */}
            {mainTab === 2 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: '100%', border: '1px solid #ccc' }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    Sms Gateway
                  </Typography>

                  <Grid item xs={12}>
                    <TextField
                      sx={{
                        width: '100%', // ensures full width
                        minWidth: { xs: '210px', sm: '5px' }, // optional
                      }}
                      select
                      size="small"
                      fullWidth
                      label={t('configuration.selectSmsGateway')}
                      placeholder={t('configuration.selectSmsGateway')}
                      value={selectedGateway}
                      onChange={(e) => setSelectedGateway(e.target.value)}
                    >
                      <MenuItem value="infobip">infobip</MenuItem>
                      <MenuItem value="connectweb">connectweb</MenuItem>
                      <MenuItem value="bulksms">bulksms</MenuItem>
                      <MenuItem value="indiasms">indiasms</MenuItem>
                      <MenuItem value="logonutility">logonutility</MenuItem>
                    </TextField>
                  </Grid>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      onClick={handleSmsGatewayUpdate}
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 3,
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
                {/* <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    mt: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Sms Status
                  </Typography>

                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isSmsChecked}
                          onChange={(e) => setIsSmsChecked(e.target.checked)}
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          Enable
                        </Typography>
                      }
                    />
                  </FormGroup>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleSaveSmsStatus}
                    >
                      Save
                    </Button>
                  )}
                </Paper> */}
              </>
            )}

            {/*  Cash free Keys and paytm keys section*/}
            {mainTab === 3 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label="Cash free Keys" />
                  <Tab label="Paytm Keys" />
                  <Tab label="Payg Keys" />
                  <Tab label="CCavenue Keys" />
                  <Tab label="Nomod Keys" />
                </Tabs>
                {subTab === 0 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Cash free Keys
                      </Typography>
                      {/* Cash free client and cash free secret key Texfield and Button */}
                      <Grid container spacing={2}>
                        <Grid size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.cashfreeClientId')}
                            placeholder={t('configuration.cashfreeClientId')}
                            value={clientId}
                            onChange={(e) => setClientId(e.target.value)}
                          />
                        </Grid>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.cashfreeSecretKey')}
                            placeholder="cashfree secret key"
                            value={secretKey}
                            onChange={(e) => setSecretKey(e.target.value)}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={4}
                          display="flex"
                          alignItems="center"
                        >
                          {(canCreateSetting || canEdit) && (
                            <Button
                              variant="contained"
                              sx={{
                                bgcolor: '#752ADA',
                                px: 6,
                                textTransform: 'none',
                                mt: 3,
                              }}
                              onClick={handleSaveCashfree}
                            >
                              Save
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </>
                )}

                {/* Paytm Keys */}
                {subTab === 1 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 'bold', mb: 1, fontSize: 20 }}
                      >
                        Paytm Keys
                      </Typography>
                      {/* mid and payg autokey Texfield and Button */}
                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.mid')}
                            placeholder="mid"
                            value={mID}
                            onChange={(e) => setMID(e.target.value)}
                          />
                        </Grid>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label="payg autokey"
                            placeholder="payg autokey"
                            value={merchantKey}
                            onChange={(e) => setMerchantKey(e.target.value)}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={4}
                          display="flex"
                          alignItems="center"
                        >
                          {(canCreateSetting || canEdit) && (
                            <Button
                              variant="contained"
                              sx={{
                                bgcolor: '#752ADA',
                                px: 6,
                                textTransform: 'none',
                                mt: 3,
                              }}
                              onClick={handleSavePaytmKeys}
                            >
                              Save
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </>
                )}

                {/* Payg Keys and ccavenue keys section*/}
                {subTab === 2 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Payg Keys{' '}
                      </Typography>
                      {/* payg mid ,authkey and payg auth token Texfield and Button */}
                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.paygMid')}
                            placeholder="payg mid"
                            value={paygmid}
                            onChange={(e) => setpaygmid(e.target.value)}
                          />
                        </Grid>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.paygAuthkey')}
                            placeholder="payg authkey"
                            value={paygAuthKey}
                            onChange={(e) => setPaygAuthKey(e.target.value)}
                          />
                        </Grid>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.paygAuthToken')}
                            placeholder="payg auth token"
                            value={paygAuthToken}
                            onChange={(e) => setPaygAuthToken(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                      {/* save button */}
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            textTransform: 'none',
                            mt: 4,
                            px: 6,
                          }}
                          onClick={handleSavePaygKey}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {/* ccavenue Key */}
                {subTab === 3 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        CCavenue Keys{' '}
                      </Typography>
                      {/* ccavenue merchant id ,merchant accesscode and working key Texfield and Button */}
                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.ccavenueMerchantId')}
                            placeholder="ccavenue merchant id"
                            value={ccavenueMerchantId}
                            onChange={(e) =>
                              setCcavenueMerchantId(e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.merchantAccesscode')}
                            placeholder="merchant accesscode"
                            value={ccavenueAccessCode}
                            onChange={(e) =>
                              setCcavenueAccessCode(e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.workingKey')}
                            placeholder="working key"
                            value={ccavenueWorkingKey}
                            onChange={(e) =>
                              setCcavenueWorkingKey(e.target.value)
                            }
                          />
                        </Grid>
                      </Grid>
                      {/* Save button */}
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            textTransform: 'none',
                            mt: 4,
                            px: 6,
                          }}
                          onClick={handleSaveccavenue}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {/* Nomod Keys */}
                {subTab === 4 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Nomod Keys
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label="Nomod Key"
                            placeholder="Nomod key"
                            value={nomodKey}
                            onChange={(e) => setNomodKey(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            textTransform: 'none',
                            mt: 4,
                            px: 6,
                          }}
                          onClick={handleSaveNomodKeys}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
              </>
            )}

            {/* Billing Integration */}
            {mainTab === 4 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label={t('configuration.billingGateway')} />
                  <Tab label={t('configuration.retailwareConfiguration')} />
                  <Tab label={t('configuration.acmeConfiguration')} />
                </Tabs>

                {/* Billing Gateway Sub-tab */}
                {subTab === 0 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Billing Integration
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isBilling}
                                  onChange={(e) =>
                                    setIsBilling(e.target.checked)
                                  }
                                  sx={{
                                    color: '#7b8499',
                                    '&.Mui-checked': {
                                      color: '#4caf50',
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography
                                  variant="body2"
                                  fontFamily={'Inter'}
                                  fontSize={'14px'}
                                  fontWeight={'500'}
                                  color="#7b8499"
                                >
                                  Active Gateway
                                </Typography>
                              }
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            sx={{
                              width: '100%', // ensures full width
                              minWidth: { xs: '210px', sm: '500px' }, // optional
                            }}
                            select
                            size="small"
                            fullWidth
                            label={t('configuration.selectBillingGateway')}
                            value={billingType}
                            onChange={(e) => setBillingType(e.target.value)}
                          >
                            <MenuItem value="Billing">
                              Select Billing Gateway
                            </MenuItem>
                            <MenuItem value="acme">acme</MenuItem>
                            <MenuItem value="retailware">retailware</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          onClick={handleSaveBilling}
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>

                    <Dialog
                      open={openDialog}
                      onClose={() => setOpenDialog(false)}
                      PaperProps={{
                        sx: {
                          borderRadius: 3,
                          padding: 3,
                          minWidth: { xs: 300, sm: 400 },
                          boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                        },
                      }}
                    >
                      {/* Icon at the top */}
                      <Box
                        sx={{
                          bgcolor: '#E3F2FD',
                          borderRadius: '50%',
                          width: 60,
                          height: 60,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mb: 2,
                        }}
                      >
                        <InfoOutlinedIcon
                          sx={{ color: '#2196F3', fontSize: 32 }}
                        />
                      </Box>

                      {/* Dialog Message */}
                      <DialogContent>
                        <Typography fontSize={18} fontWeight={600}>
                          Kindly select billing gateway
                        </Typography>
                      </DialogContent>

                      {/* Dialog Action Button */}
                      <DialogActions sx={{ justifyContent: 'center' }}>
                        <Button
                          onClick={() => setOpenDialog(false)}
                          variant="contained"
                          sx={{
                            bgcolor: '#2196F3',
                            color: '#fff',
                            textTransform: 'none',
                            px: 4,
                            borderRadius: 2,
                            '&:hover': { bgcolor: '#1976D2' },
                          }}
                        >
                          OK
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                )}

                {/* Retail ware Configuration Sub-tab */}
                {subTab === 1 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Retail ware Configuration
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.url')}
                            placeholder={t('configuration.urlPlaceholder')}
                            value={retailwareUrl}
                            onChange={(e) => {
                              const input = e.target.value;

                              setRetailwareUrl(input);
                            }}
                          />
                        </Grid>
                      </Grid>
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleRetailwareUrl}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {/* Acme Configuration Sub-tab */}
                {subTab === 2 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Acme Configuration
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.url')}
                            placeholder={t('configuration.urlPlaceholder')}
                            value={acme}
                            onChange={(e) => {
                              const input = e.target.value;
                              const urlRegex =
                                /^(https?:\/\/)?([\w\-]+\.)+[\w\-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

                              if (input === '' || urlRegex.test(input)) {
                                setAcmeUrl(input);
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleAcmeUrl}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
              </>
            )}

            {/* Firebase Configuration */}
            {mainTab === 5 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: '100%',
                    border: '1px solid #ccc',
                  }}
                >
                  <Tabs
                    value={subTab}
                    onChange={(e, val) => setSubTab(val)}
                    sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
                  >
                    <Tab label="Firebase Configuration" />
                    <Tab label="Admin app Firebase configuration" />
                  </Tabs>

                  {/* Customer app Firebase configuration */}
                  {subTab === 0 && (
                    <>
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Firebase Configuration
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.firebaseProjectId')}
                            placeholder="firebase project id"
                            value={firebaseConfig.firebaseProjectId}
                            onChange={(e) =>
                              setFirebaseConfig({
                                ...firebaseConfig,
                                firebaseProjectId: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.topicName')}
                            placeholder="topic name"
                            value={firebaseConfig.topicName}
                            onChange={(e) =>
                              setFirebaseConfig({
                                ...firebaseConfig,
                                topicName: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item size={12}>
                          <Button
                            variant="outlined"
                            component="label"
                            sx={{
                              color: '#752ADA',
                              border: '1px solid #752ADA',
                            }}
                          >
                            Choose SDK Path
                            <input
                              type="file"
                              hidden
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  setFirebaseConfig({
                                    ...firebaseConfig,
                                    firebaseSdkPath: file,
                                  });
                                }
                              }}
                            />
                          </Button>
                          {firebaseConfig.firebaseSdkPath && (
                            <Box mt={2}>
                              <Typography variant="body2" mb={1}>
                                Selected JSON file:
                              </Typography>
                              {typeof firebaseConfig.firebaseSdkPath ===
                              'string' ? (
                                <Button
                                  variant="outlined"
                                  onClick={() =>
                                    handlePreviewFile(
                                      firebaseConfig.firebaseSdkPath,
                                    )
                                  }
                                  sx={{
                                    color: '#752ADA',
                                    border: '1px solid #752ADA',
                                    textTransform: 'none',
                                  }}
                                >
                                  Preview
                                </Button>
                              ) : (
                                <Typography variant="body2">
                                  {firebaseConfig.firebaseSdkPath.name}
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Grid>
                      </Grid>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            textTransform: 'none',
                            px: 6,
                            mt: 4,
                          }}
                          onClick={handleSaveFirebaseConfig}
                        >
                          Save
                        </Button>
                      )}
                    </>
                  )}

                  {/* Admin app Firebase configuration */}
                  {subTab === 1 && (
                    <>
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Admin app Firebase configuration
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item size={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label={t('configuration.firebaseProjectId')}
                            placeholder="firebase project id"
                            value={adminFirebaseConfig.firebaseProjectId}
                            onChange={(e) =>
                              setAdminFirebaseConfig({
                                ...adminFirebaseConfig,
                                firebaseProjectId: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item size={12}>
                          <Button
                            variant="outlined"
                            component="label"
                            sx={{
                              color: '#752ADA',
                              border: '1px solid #752ADA',
                            }}
                          >
                            Choose Service Account JSON
                            <input
                              type="file"
                              hidden
                              accept="application/json,.json"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  setAdminFirebaseConfig({
                                    ...adminFirebaseConfig,
                                    firebaseSdkPath: file,
                                  });
                                }
                              }}
                            />
                          </Button>

                          {adminFirebaseConfig.firebaseSdkPath && (
                            <Box mt={2}>
                              <Typography variant="body2" mb={1}>
                                Selected JSON file:
                              </Typography>
                              {typeof adminFirebaseConfig.firebaseSdkPath ===
                              'string' ? (
                                <Button
                                  variant="outlined"
                                  onClick={() =>
                                    handlePreviewFile(
                                      adminFirebaseConfig.firebaseSdkPath,
                                    )
                                  }
                                  sx={{
                                    color: '#752ADA',
                                    border: '1px solid #752ADA',
                                    textTransform: 'none',
                                  }}
                                >
                                  Preview
                                </Button>
                              ) : (
                                <Typography variant="body2">
                                  {adminFirebaseConfig.firebaseSdkPath.name}
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Grid>
                      </Grid>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            textTransform: 'none',
                            px: 6,
                            mt: 4,
                          }}
                          onClick={handleSaveAdminFirebaseConfig}
                        >
                          Save
                        </Button>
                      )}
                    </>
                  )}
                </Paper>
              </>
            )}

            {/* One link URL */}
            {mainTab === 6 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, mt: 3, width: '100%', border: '1px solid #ccc' }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    One link URL{' '}
                  </Typography>
                  {/*App Url textfield container */}

                  <Grid container spacing={2}>
                    <Grid item size={12}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('configuration.appLink')}
                        placeholder={t('configuration.urlPlaceholder')}
                        value={appurl}
                        onChange={(e) => {
                          const input = e.target.value;
                          const urlRegex =
                            /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

                          if (input === '' || urlRegex.test(input)) {
                            setAppUrl(input);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 3,
                      }}
                      onClick={handleAppUrl}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {/* Carousel Lookbook Status */}
            {mainTab === 7 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: '100%',
                    border: '1px solid #ccc',
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    Carousel Lookbook Status
                  </Typography>

                  <FormGroup row sx={{ color: '#7B8499' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={(e) => setIsChecked(e.target.checked)}
                          sx={{
                            color: '#7b8499',
                            '&.Mui-checked': {
                              color: '#4caf50',
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={'Inter'}
                          fontSize={'14px'}
                          fontWeight={'500'}
                          color="#7b8499"
                        >
                          Enable
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 3,
                      }}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {/* bullion deposite status */}
            {mainTab === 8 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label={t('configuration.bullionDepositStatus')} />
                  <Tab
                    label={t('configuration.bullionDepositBenefitTransfer')}
                  />
                </Tabs>
                {subTab === 0 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Bullion Deposit Status
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isCheckedBullion}
                              onChange={(e) =>
                                setIsCheckedBullion(e.target.checked)
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Enable
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveBullion}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {/* Bullion Deposit Benefit Transfer */}
                {subTab === 1 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Bullion Deposit Benefit Transfer
                      </Typography>

                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        maxWidth={900}
                      >
                        {/* Holdings Checkbox */}
                        <FormControlLabel
                          sx={{
                            width: '50%',
                            maxWidth: { xs: '210px', sm: '353px' },
                          }}
                          control={
                            <Checkbox
                              checked={holdings}
                              onChange={handleHoldingsChange}
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Holdings (
                              <span>
                                IF holding is selected, metal can be sold and
                                redeemed by the customer.
                              </span>
                              )
                            </Typography>
                          }
                        />

                        {/* Gift Balance Checkbox */}
                        <FormControlLabel
                          sx={{
                            width: '50%',
                            maxWidth: { xs: '210px', sm: '353px' },
                          }}
                          control={
                            <Checkbox
                              checked={giftbalance}
                              onChange={handleGiftBalanceChange}
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Gift Balance (
                              <span>
                                IF gift is selected, metal can only be redeemed
                                by the customer.
                              </span>
                              )
                            </Typography>
                          }
                        />
                      </Box>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveBullionDeposit}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
              </>
            )}

            {/* Registration and Birthday  Gift Status section*/}
            {mainTab === 9 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label={t('configuration.registrationGiftStatus')} />
                  <Tab label={t('configuration.birthdayGiftStatus')} />
                  <Tab label={t('configuration.showOldGiftPopup')} />
                </Tabs>
                {subTab === 0 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Registration Gift Status
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isCheckedRegistration}
                              onChange={(e) =>
                                setIsCheckedRegistration(e.target.checked)
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Enable
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveRegistration}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {subTab === 1 && (
                  <>
                    {/* Birthdat gifth status checkbox */}
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Birthday Gift Status
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isCheckedBirthday}
                              onChange={(e) =>
                                setIsCheckedBirthday(e.target.checked)
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Enable
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveBirthday}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
                {subTab === 2 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Show Old Gift Popup
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isCheckedOldGift}
                              onChange={(e) =>
                                setIsCheckedOldGift(e.target.checked)
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Enable
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveoldgiftpopup}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
              </>
            )}

            {/* Dashboard Login Options */}
            {mainTab === 10 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: '100%',
                    border: '1px solid #ccc',
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    Dashboard Login Options
                  </Typography>

                  <FormGroup row sx={{ color: '#7B8499', gap: 7 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={loginOptions.EMAIL}
                          onChange={(e) =>
                            setLoginOptions((prev) => ({
                              ...prev,
                              EMAIL: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#7b8499',
                            '&.Mui-checked': {
                              color: '#4caf50',
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={'Inter'}
                          fontSize={'14px'}
                          fontWeight={'500'}
                          color="#7b8499"
                        >
                          Email
                        </Typography>
                      }
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={loginOptions.SMS}
                          onChange={(e) =>
                            setLoginOptions((prev) => ({
                              ...prev,
                              SMS: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#7b8499',
                            '&.Mui-checked': {
                              color: '#4caf50',
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={'Inter'}
                          fontSize={'14px'}
                          fontWeight={'500'}
                          color="#7b8499"
                        >
                          SMS
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 3,
                      }}
                      onClick={handleSaveLoginOptions}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {/* SIP product options */}
            {mainTab === 11 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label={t('configuration.showProductOptions')} />
                  <Tab label={t('configuration.productPurchase')} />
                </Tabs>
                {subTab === 0 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Show Product Options
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499', gap: 7 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={productOptions.booknow}
                              onChange={(e) =>
                                setProductOptions((prev) => ({
                                  ...prev,
                                  booknow: e.target.checked,
                                }))
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Book Now
                            </Typography>
                          }
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={productOptions.enquirenow}
                              onChange={(e) =>
                                setProductOptions((prev) => ({
                                  ...prev,
                                  enquirenow: e.target.checked,
                                }))
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Enquire Now
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveProductOptions}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {subTab === 1 && (
                  <>
                    {/* Product purchase   */}
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        Product Purchase
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499', gap: 7 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={productPurchase.online}
                              onChange={(e) =>
                                setProductPurchase((prev) => ({
                                  ...prev,
                                  online: e.target.checked,
                                }))
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Online
                            </Typography>
                          }
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={productPurchase.offline}
                              onChange={(e) =>
                                setProductPurchase((prev) => ({
                                  ...prev,
                                  offline: e.target.checked,
                                }))
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Offline
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveProductPurchase}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
              </>
            )}

            {/* Sip status  */}
            {mainTab === 12 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label={t('configuration.sipStatus')} />
                  <Tab label={t('configuration.sipPlanConfiguration')} />
                </Tabs>
                {subTab === 0 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        SIP Status
                      </Typography>

                      <FormGroup row sx={{ color: '#7B8499', gap: 7 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={sipStatus.moneysipstatus}
                              onChange={(e) =>
                                setSipStatus((prev) => ({
                                  ...prev,
                                  moneysipstatus: e.target.checked,
                                }))
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Money
                            </Typography>
                          }
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={sipStatus.metalsipstatus}
                              onChange={(e) =>
                                setSipStatus((prev) => ({
                                  ...prev,
                                  metalsipstatus: e.target.checked,
                                }))
                              }
                              sx={{
                                color: '#7b8499',
                                '&.Mui-checked': {
                                  color: '#4caf50',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              fontFamily={'Inter'}
                              fontSize={'14px'}
                              fontWeight={'500'}
                              color="#7b8499"
                            >
                              Metal
                            </Typography>
                          }
                        />
                      </FormGroup>

                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveSipStatus}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}

                {/* SIP Plan Configuration */}
                {subTab === 1 && (
                  <>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 3,
                        mt: 3,
                        width: '100%',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        fontSize={24}
                        mb={3}
                        fontFamily={'Aeonik'}
                      >
                        SIP Plan Configuration{' '}
                      </Typography>
                      {/* min month ,max month and min amount  textfield  container */}
                      <Grid
                        container
                        spacing={3}
                        sx={{ mt: '10px', width: '100%' }}
                      >
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Min Month"
                            placeholder="Min Month"
                            size="small"
                            type="number"
                            value={minMonth}
                            onChange={(e) => {
                              const input = e.target.value;
                              const number = parseInt(input, 10);

                              // Allow empty field or valid month (1 to 12)
                              if (
                                input === '' ||
                                (number >= 1 && number <= 99)
                              ) {
                                setMinMonth(input);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Max Month"
                            placeholder="Max Month"
                            size="small"
                            type="number"
                            value={maxMonth}
                            onChange={(e) => {
                              const input = e.target.value;
                              const number = parseInt(input, 10);

                              if (
                                input === '' ||
                                (number >= 1 && number <= 99)
                              ) {
                                setMaxMonth(input);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Min Amount"
                            placeholder="Min Amount"
                            size="small"
                            value={minAmount}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (/^[1-9][0-9]*$/.test(input) || input === '') {
                                setMinAmount(input);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Max Amount"
                            placeholder="Max Amount"
                            size="small"
                            value={maxAmount}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (/^[1-9][0-9]*$/.test(input) || input === '') {
                                setMaxAmount(input);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Min Gram"
                            placeholder="Min Gram"
                            size="small"
                            value={minGram}
                            onChange={(e) => {
                              const input = e.target.value;
                              // allow decimals like 0.5, 1.250 etc.
                              if (
                                /^\d*\.?\d{0,3}$/.test(input) ||
                                input === ''
                              ) {
                                setMinGram(input);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Max Gram"
                            placeholder="Max Gram"
                            size="small"
                            value={maxGram}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (
                                /^\d*\.?\d{0,3}$/.test(input) ||
                                input === ''
                              ) {
                                setMaxGram(input);
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                      {/* Max amount and save button */}
                      {(canCreateSetting || canEdit) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: '#752ADA',
                            px: 6,
                            textTransform: 'none',
                            mt: 3,
                          }}
                          onClick={handleSaveSipConfig}
                        >
                          Save
                        </Button>
                      )}
                    </Paper>
                  </>
                )}
              </>
            )}
            {/* Countries */}
            {mainTab === 13 && (
              <>
                <CreateCountryList />
              </>
            )}

            {/* Control All Features */}
            {mainTab === 14 && (
              <Reusable
                label="Control All Feature"
                options={getControlAllFeatureOptionList(featuresData)}
                selected={featureToggle}
                onChange={setFeatureToggle}
                onSave={() =>
                  dispatch(
                    updateConfigRequest({
                      key: 'featureToggle',
                      value: featureToggle,
                    }),
                  )
                }
                showButton={canCreateSetting || canEdit}
              />
            )}

            {/* Jeweller And Customer Notification */}
            {mainTab === 15 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: '100%',
                    border: '1px solid #ccc',
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    Notification & Grace Period Settings
                  </Typography>

                  <FormGroup sx={{ gap: 3, maxWidth: 400 }}>
                    {/* Notify Jeweller Days */}
                    <TextField
                      label="Notify Jeweller Days"
                      type="number"
                      value={graceSettings.notifyJewellerDays}
                      error={graceSettings.notifyJewellerDays < 0}
                      helperText={
                        graceSettings.notifyJewellerDays < 0
                          ? 'Value cannot be less than 0'
                          : 'Enter 0 for no notification'
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue === '') {
                          setGraceSettings((prev) => ({
                            ...prev,
                            notifyJewellerDays: '',
                          }));
                          return;
                        }
                        if (!/^\d*$/.test(inputValue)) return;
                        const value = Number(inputValue);
                        if (value >= 0) {
                          setGraceSettings((prev) => ({
                            ...prev,
                            notifyJewellerDays: value,
                          }));
                        }
                      }}
                    />

                    {/* Notify Customer Days */}
                    <TextField
                      label="Notify Customer Days"
                      type="number"
                      value={graceSettings.notifyCustomerDays}
                      error={graceSettings.notifyCustomerDays < 0}
                      helperText={
                        graceSettings.notifyCustomerDays < 0
                          ? 'Value cannot be less than 0'
                          : 'Enter 0 for no notification'
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue === '') {
                          setGraceSettings((prev) => ({
                            ...prev,
                            notifyCustomerDays: '',
                          }));
                          return;
                        }
                        if (!/^\d*$/.test(inputValue)) return;
                        const value = Number(inputValue);
                        if (value >= 0) {
                          setGraceSettings((prev) => ({
                            ...prev,
                            notifyCustomerDays: value,
                          }));
                        }
                      }}
                    />

                    {/* Grace Period Days */}
                    <TextField
                      label="Buffer Period Days For Jeweller"
                      type="number"
                      value={graceSettings.gracePeriodDays}
                      error={graceSettings.gracePeriodDays < 0}
                      helperText={
                        graceSettings.gracePeriodDays < 0
                          ? 'Value cannot be less than 0'
                          : 'Enter 0 for no grace period'
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue === '') {
                          setGraceSettings((prev) => ({
                            ...prev,
                            gracePeriodDays: '',
                          }));
                          return;
                        }
                        if (!/^\d*$/.test(inputValue)) return;
                        const value = Number(inputValue);
                        if (value >= 0) {
                          setGraceSettings((prev) => ({
                            ...prev,
                            gracePeriodDays: value,
                          }));
                        }
                      }}
                    />

                    {/* Grace Period Days For Customer */}
                    <TextField
                      label="Buffer Period Days For Customer"
                      type="number"
                      value={graceSettings.gracePeriodDaysForCustomer}
                      error={graceSettings.gracePeriodDaysForCustomer < 0}
                      helperText={
                        graceSettings.gracePeriodDaysForCustomer < 0
                          ? 'Value cannot be less than 0'
                          : 'Enter 0 for no grace period'
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue === '') {
                          setGraceSettings((prev) => ({
                            ...prev,
                            gracePeriodDaysForCustomer: '',
                          }));
                          return;
                        }
                        if (!/^\d*$/.test(inputValue)) return;
                        const value = Number(inputValue);
                        if (value >= 0) {
                          setGraceSettings((prev) => ({
                            ...prev,
                            gracePeriodDaysForCustomer: value,
                          }));
                        }
                      }}
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 4,
                      }}
                      disabled={
                        graceSettings.notifyJewellerDays < 0 ||
                        graceSettings.notifyCustomerDays < 0 ||
                        graceSettings.gracePeriodDays < 0
                      }
                      onClick={handleSaveGraceSettings}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}
            {/* Buy Auto Debit */}
            {mainTab === 16 && (
              <AccessControl feature={controlAllFeatureOptions.Buy_Auto_Debit}>
                <Box sx={{ mt: 0 }}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: '100%',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Typography fontWeight={700} fontSize={24} mb={3}>
                      Buy Auto Debit Settings
                    </Typography>

                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={frequency.DAY}
                            onChange={handleChangeBuyAutoDebit('DAY')}
                          />
                        }
                        label="Daily"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={frequency.WEEK}
                            onChange={handleChangeBuyAutoDebit('WEEK')}
                          />
                        }
                        label="Weekly"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={frequency.MONTH}
                            onChange={handleChangeBuyAutoDebit('MONTH')}
                          />
                        }
                        label="Monthly"
                      />
                    </FormGroup>

                    <Button
                      variant="contained"
                      sx={{ mt: 3 }}
                      onClick={handleSaveBuyAutoDebit}
                    >
                      Save
                    </Button>
                  </Paper>
                </Box>
              </AccessControl>
            )}

            {mainTab === 17 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: '100%', border: '1px solid #ccc' }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={'Aeonik'}
                  >
                    Jeweller Subcription On Boarding Days
                  </Typography>
                  {/*Look Book  Texfield and Button */}
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      type="number"
                      inputProps={{ min: 0, step: 1 }}
                      value={jewellerOnBoardingDays}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only integer numbers
                        if (/^\d*$/.test(value)) {
                          setJewellerOnBoardingDays(value);
                        }
                      }}
                    />
                  </Grid>
                  {/* add button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#752ADA',
                        px: 6,
                        textTransform: 'none',
                        mt: 3,
                      }}
                      onClick={handelJewellerOnBoardingDays}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}
            {mainTab === 18 && (
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc", mt: 2 }}
                >
                  <Typography fontWeight={700} fontSize={24} fontFamily={"Aeonik"}>
                      {t("configuration.appVersion")}
                  </Typography>
                  <Typography mb={3}>{t("configuration.appVersionDesc")}</Typography>
            
                  <Grid container spacing={2}>
                      <Grid item size={4}>
                        <TextField
                          select
                          label={
                            <>
                              {t("configuration.appVersionType")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </>
                          }
                          size="small"
                          value={appVersion.type}
                          onChange={(e) =>
                          setAppVersion({ ...appVersion, type: e.target.value })
                          }
                            fullWidth
                        >
                          <MenuItem value="old">{t("configuration.old")}</MenuItem>
                          <MenuItem value="new">{t("configuration.new")}</MenuItem>
                        </TextField>
                      </Grid>
            
                      <Grid item xs={12}>
                        {(canCreateSetting || canEdit) && (
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#752ADA", textTransform: "none" }}
                            onClick={handleSaveAppVersion}
                            disabled={isSavingAppVersion}
                          >
                            {isSavingAppVersion ? t("settings.saving") : t("settings.save")}
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Paper>
                )}
            {mainTab === 19 && (
              <DocumentConfiguration canSave={canCreateSetting || canEdit} />
            )}
          </Box>
        </Box>
      </Box>
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle fontWeight={600}>Confirm SMS Quantity Update</DialogTitle>

        <DialogContent>
          <Typography mb={1}>
            Current SMS Balance: <b>{existingBalance}</b>
          </Typography>

          <Typography mb={1}>
            SMS Quantity to Add: <b>{smsCount || 0}</b>
          </Typography>

          <Typography>
            After update, SMS balance will be{' '}
            <b>{existingBalance + Number(smsCount || 0)}</b>
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenConfirm(false)}
            sx={{ textTransform: 'none' }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            sx={{ bgcolor: '#752ADA', textTransform: 'none' }}
            onClick={handelSmsCount}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Configuration;
